import Header from '../components/Header';
import Hero from '../components/Hero';
import Destinations from '../components/Destinations';
import SafariBanner from '../components/SafariBanner';
import Features from '../components/Features';
import Corporate from '../components/Corporate';
import QuoteForm from '../components/QuoteForm';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Hero />
        <Destinations />
        <SafariBanner />
        <Features />
        <Corporate />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
